import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;

export const TriggerButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  /* 2.25rem para o alvo de toque; o ícone dentro é bem menor que isso. */
  width: 2.25rem;
  height: 2.25rem;
  border: none;
  border-radius: 50%;
  background: none;
  cursor: pointer;
  transition: background 0.15s ease;

  &:hover,
  &[aria-expanded='true'] {
    background: rgba(50, 54, 80, 0.06);
  }

  &:focus-visible {
    outline: 2px solid #1e88e5;
    outline-offset: 2px;
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

/**
 * A lista segue o desenho do dropdown do filtro do feed — mesmo raio, mesma
 * sombra, mesma altura de item — para as duas coisas não parecerem de
 * aplicativos diferentes.
 *
 * Ancorada à direita porque o gatilho fica na borda direita do cabeçalho:
 * aberta a partir da esquerda, ela sairia da tela no celular.
 */
export const MenuList = styled.ul<{ $open: boolean }>`
  position: absolute;
  top: 2.6rem;
  right: 0;
  z-index: 1500;
  min-width: 11rem;
  margin: 0;
  padding: 0;
  list-style: none;
  background: #fff;
  border-radius: 0.8rem;
  box-shadow: 0px 10px 30px rgba(85, 85, 85, 0.16);
  overflow: hidden;

  > li {
    width: 100%;

    &:not(:last-child) {
      border-bottom: 1px solid #e0e0e0;
    }

    > button {
      width: 100%;
      height: 2.6rem;
      display: flex;
      align-items: center;
      gap: 0.7rem;
      padding: 0 1rem;
      border: none;
      background: none;
      cursor: pointer;
      font-family: 'RedHatDisplay-Medium';
      font-size: 0.9rem;
      color: #323232;
      white-space: nowrap;
      transition: background 0.2s ease;

      &:hover {
        background: rgba(50, 54, 80, 0.05);
      }

      &:focus-visible {
        outline: 2px solid #1e88e5;
        outline-offset: -2px;
      }

      /* Mesma cor de risco que o feed já usa no último item do filtro. */
      &.destructive {
        color: #e53935;

        &:hover {
          background: rgba(255, 46, 62, 0.05);
        }
      }

      @media (prefers-reduced-motion: reduce) {
        transition: none;
      }
    }
  }
`;
